import React from 'react';
import PropTypes from 'prop-types';
import { Box, Grid, IconButton, Tooltip } from '@material-ui/core';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import Card from '../../Card/Card.js';
import CardBody from '../../Card/CardBody.js';
import HomeIcon from '@material-ui/icons/Home';
import AddIcon from '@material-ui/icons/Add';
import HelpOutlineIcon from '@material-ui/icons/Timer';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import RecommendationIcon from '../../../assets/img/planner-recommendations-icon.svg';
import { dateDiffDays, dateToS } from '../../../util/dateUtil';
import { isStudent, isAlumni, isFHT } from '../../../util/miscUtil';

const Recommendations = ({
  senior,
  alumni,
  roles,
  formatPhoneNumber,
  recommendationList,
  handleCreateRecommendationRequest,
  openRecommendation,
  displayStatus,
  aftercareSpecialist,
  setPage,
  handleReturnToSeniorList,
  classes,
  handleGotoAdminHomepage,
}) => {
  window.scrollTo({ top: 0 });

  const decipherRecommendationAreas = (app) => {
    let areas = [];
    if (app.recommendation_json && app.recommendation_json.length > 0) {
      const rec_json = JSON.parse(app.recommendation_json);
      if (rec_json.scholarships) {
        areas.push('Scholarships');
      }
      if (rec_json.tradeLife) {
        areas.push('Community Supports');
      }
      if (rec_json.housing) {
        areas.push('Housing');
      }
    }
    return areas;
  };

  const getFhpInfo = (app) => {
    if (!app?.recommendation_json) return 'No';
    try {
      const rec_json = JSON.parse(app.recommendation_json);
      return rec_json?.meetsFhpHousingRequirements ? 'Yes' : 'No';
    } catch {
      return 'No';
    }
  };

  const isRequestCompletedOrExpired = (app) => {
    if (
      app.status.toLowerCase() === 'complete' ||
      (app.status.toLowerCase() === 'requested' && dateDiffDays(dateToS(app.last_date_requested)) < -32) ||
      (app.status.toLowerCase() === 're-requested' && dateDiffDays(dateToS(app.last_date_requested)) < -32)
    ) {
      return true;
    }
    return false;
  };

  return (
    <summary className={classes.subPageContainer}>
      <div style={{ width: '100%', margin: 0 }} className={classes.pageBanner}>
        <div className={classes.centerForm}>
          <Box
            sx={{
              width: '100%',
              maxWidth: {
                xs: '380px',
                sm: '540px',
                md: '868px',
                lg: '1320px',
                xl: '1320px',
              },
            }}
          >
            <Grid container spacing={0} direction="row">
              <Grid item xs={12} align="left">
                <summary className={classes.header} style={{ paddingTop: '30px' }}>
                  <Grid container direction="row" style={{ width: '100%' }}>
                    <Grid item xs={false} sm={1} md={1} lg={1} align="center" className={classes.logoContainer}>
                      <img src={RecommendationIcon} alt="Letters of Recommendation Icon" className={classes.logo} />
                    </Grid>
                    <Grid item xs={12} sm={11} md={11} lg={11} align="left">
                      <Grid container spacing={0} direction="row" style={{ width: '100%' }}>
                        <Grid item xs={9} sm={10} md={10} lg={11} align="left" style={{ width: '100%' }}>
                          <div className={classes.headerContent}>
                            <div className={classes.headerText}>
                              <div className={classes.title}>
                                {isStudent(roles) || isAlumni(roles) ? (
                                  <main>Letters of Recommendation</main>
                                ) : (
                                  <main>
                                    Letters of Recommendation for{' '}
                                    {senior.alumni_updated_first_name ? senior.alumni_updated_first_name : senior.first_name}{' '}
                                    {senior.alumni_updated_last_name ? senior.alumni_updated_last_name : senior.last_name}
                                  </main>
                                )}
                              </div>
                            </div>
                          </div>
                        </Grid>
                        <Grid item xs={3} sm={2} md={2} lg={1} align="center" style={{ width: '100%' }}>
                          <IconButton color="inherit" aria-label="return home" onClick={(e) => setPage('home')}>
                            <HomeIcon className={classes.homeIcon} style={{ color: '#fff' }} />
                          </IconButton>
                        </Grid>
                        <Grid item xs={12} md={6} lg={6} style={{ marginTop: '15px' }}>
                          <aside style={{ textAlign: 'left' }}>
                            <label className={classes.subPageContactInfoLabel}>Successful Futures Specialist:</label>{' '}
                            <span className={classes.subPageContactInfo}>
                              {aftercareSpecialist && aftercareSpecialist.user && aftercareSpecialist.user.id > 0
                                ? aftercareSpecialist.user.first_name + ' ' + aftercareSpecialist.user.last_name
                                : 'N/A'}
                            </span>
                          </aside>
                          <aside style={{ textAlign: 'left' }}>
                            <label className={classes.subPageContactInfoLabel}>Office Phone</label>{' '}
                            <span className={classes.subPageContactInfo}>
                              {(aftercareSpecialist &&
                                aftercareSpecialist.user &&
                                aftercareSpecialist.user.id > 0 &&
                                formatPhoneNumber(aftercareSpecialist.office_phone)) ||
                                'N/A'}
                            </span>
                          </aside>
                          <aside style={{ textAlign: 'left' }}>
                            <label className={classes.subPageContactInfoLabel}>Cell Phone</label>{' '}
                            <span className={classes.subPageContactInfo}>
                              {(aftercareSpecialist &&
                                aftercareSpecialist.user &&
                                aftercareSpecialist.user.id > 0 &&
                                formatPhoneNumber(aftercareSpecialist.cell_phone)) ||
                                'N/A'}
                            </span>
                          </aside>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </summary>
              </Grid>
            </Grid>
          </Box>
        </div>

        {!isStudent(roles) && !isAlumni(roles) && (
          <div className={classes.centerForm}>
            <Box
              sx={{
                width: '100%',
                maxWidth: {
                  xs: '380px',
                  sm: '540px',
                  md: '868px',
                  lg: '1280px',
                  xl: '1280px',
                },
              }}
            >
              <div className={classes.breadcrumbs}>
                <Breadcrumbs separator="›" aria-label="breadcrumbs" className={classes.alignCrumb}>
                  <span className={classes.breadCrumbLink} style={{ marginTop: '-2px' }} onClick={(e) => handleGotoAdminHomepage()}>
                    <HomeIcon style={{ fontSize: '1.30rem' }} />
                    <span style={{ margin: '1px 0 0 1px' }}>Home</span>
                  </span>
                  <span className={classes.breadCrumbLink} style={{ marginTop: '-1px' }} onClick={(event) => handleReturnToSeniorList()}>
                    {alumni ? 'Alumni' : 'High School Seniors'}
                  </span>
                  <span className={classes.breadCrumbLink} style={{ marginTop: '-1px' }} onClick={(e) => setPage('home')}>
                    {senior && senior.alumni_updated_first_name ? senior.alumni_updated_first_name : senior.first_name}{' '}
                    {senior && senior.alumni_updated_last_name ? senior.alumni_updated_last_name : senior.last_name}
                  </span>
                  <span className={classes.breadCrumbText} style={{ marginTop: '-1px' }}>
                    Letters of Recommendation
                  </span>
                </Breadcrumbs>
              </div>
            </Box>
          </div>
        )}
      </div>

      <div className={classes.centerForm}>
        <Box
          sx={{
            width: '100%',
            maxWidth: {
              xs: '380px',
              sm: '540px',
              md: '868px',
              lg: '1320px',
              xl: '1320px',
            },
          }}
        >
          <Grid container spacing={3} direction="row" style={{ marginTop: '75px' }}>
            <Grid item xs={12} align="left" className={classes.cardGrid} style={{ width: '99%' }}>
              {(isStudent(roles) || isAlumni(roles)) && (
                <nav
                  onClick={(event) => handleCreateRecommendationRequest()}
                  className={classes.nav}
                  aria-disabled={!isStudent(roles) && !isAlumni(roles)}
                >
                  <Card className={classes.recommendationCard}>
                    <CardBody className={classes.cardBody}>
                      <div className={classes.cardContainer}>
                        <img src={RecommendationIcon} alt="Recommendation Icon" className={classes.cardIcon} />

                        <Tooltip title={'Click to request a letter of recommendation.'} placement="bottom">
                          <section className={classes.addSection}>
                            <AddIcon className={classes.addIcon} />
                          </section>
                        </Tooltip>
                      </div>
                    </CardBody>
                  </Card>
                </nav>
              )}

              {recommendationList && recommendationList.length === 0 && <div>No recommendation requests found.</div>}
              {recommendationList
                .sort((a, b) => {
                  return b.last_date_requested > a.last_date_requested ? 1 : -1;
                })
                .map((app, idx) => {
                  return (
                    <nav key={`lor_${idx}`} onClick={(event) => !isFHT(roles) && openRecommendation(app.recommendation_id)} className={classes.nav}>
                      <Card
                        className={classes.recommendationCard}
                        style={{
                          backgroundColor: isRequestCompletedOrExpired(app) ? 'rgba(217, 217, 217, 0.4)' : '#fff',
                        }}
                      >
                        <CardBody className={classes.cardBody}>
                          <div className={classes.cardContainer}>
                            <img src={RecommendationIcon} alt="Recommendation Icon" className={classes.cardIcon} />
                            <section className={classes.recommendationDates}>
                              <main className={classes.cardHeader} style={{ color: isRequestCompletedOrExpired(app) && 'rgba(0, 0, 0, 0.4)' }}>
                                {app.last_name}, {app.first_name}
                                <br />
                                <label style={{ color: isRequestCompletedOrExpired(app) && 'rgba(0, 0, 0, 0.4)' }}>({app.email})</label>
                              </main>
                              <aside style={{ marginTop: '10px' }}>
                                <label style={{ color: isRequestCompletedOrExpired(app) && 'rgba(0, 0, 0, 0.4)' }}>Requested On</label>{' '}
                                <span className={classes.applicationArea} style={{ color: isRequestCompletedOrExpired(app) && 'rgba(0, 0, 0, 0.4)' }}>
                                  {dateToS(app.last_date_requested)}
                                </span>
                              </aside>
                              <aside>
                                <label style={{ color: isRequestCompletedOrExpired(app) && 'rgba(0, 0, 0, 0.4)' }}>Requested for </label>
                                <div className={classes.applicationArea} style={{ color: isRequestCompletedOrExpired(app) && 'rgba(0, 0, 0, 0.4)' }}>
                                  {decipherRecommendationAreas(app).toString()}
                                </div>
                              </aside>
                              {app.version === 2 && (
                                <aside>
                                  <label style={{ color: isRequestCompletedOrExpired(app) && 'rgba(0, 0, 0, 0.4)' }}>
                                    FHP Staff Housing Recommendation:{' '}
                                  </label>
                                  <span
                                    className={classes.applicationArea}
                                    style={{ color: isRequestCompletedOrExpired(app) && 'rgba(0, 0, 0, 0.4)' }}
                                  >
                                    {getFhpInfo(app)}
                                  </span>
                                </aside>
                              )}
                              <br />
                            </section>
                            <div style={{ marginLeft: '-10px' }}>
                              <summary
                                className={classes.cardAlignBottom}
                                style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
                              >
                                <section className={classes.appStatus} style={{ width: '100%' }}>
                                  {app.status.toLowerCase() !== 'complete' && dateDiffDays(dateToS(app.last_date_requested)) < -32 && (
                                    <div
                                      style={{
                                        color: 'rgba(0, 0, 0, 0.4)',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <HelpOutlineIcon
                                        className={classes.warningStatusIcon}
                                        style={{
                                          color: 'rgba(0, 0, 0, 0.4)',
                                        }}
                                      />{' '}
                                      <span
                                        className={classes.iconText}
                                        style={{
                                          color: 'rgba(0, 0, 0, 0.4)',
                                        }}
                                      >
                                        EXPIRED
                                      </span>
                                    </div>
                                  )}
                                  {app.status.toLowerCase() === 'complete' && (
                                    <aside
                                      style={{
                                        color: app.status.toLowerCase() === 'complete' && 'rgba(0, 0, 0, 0.4)',
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                      }}
                                    >
                                      <CheckCircleOutlineIcon /> {displayStatus(app.status)}
                                    </aside>
                                  )}
                                </section>
                                <section className={classes.appStatusDate}>
                                  <span className={classes.iconText}>{dateToS(app.status_date)}</span>
                                </section>
                              </summary>
                            </div>
                          </div>
                        </CardBody>
                      </Card>
                    </nav>
                  );
                })}
            </Grid>
          </Grid>
        </Box>
      </div>
    </summary>
  );
};

Recommendations.propTypes = {
  senior: PropTypes.object,
  alumni: PropTypes.bool,
  roles: PropTypes.array,
  formatPhoneNumber: PropTypes.func,
  recommendationList: PropTypes.array,
  handleCreateRecommendationRequest: PropTypes.func,
  openRecommendation: PropTypes.func,
  displayStatus: PropTypes.func,
  aftercareSpecialist: PropTypes.object,
  setPage: PropTypes.func,
  handleReturnToSeniorList: PropTypes.func,
  classes: PropTypes.object.isRequired,
  handleGotoAdminHomepage: PropTypes.func.isRequired,
};

export default Recommendations;
